import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { MatFormFieldControl } from '@angular/material/form-field';
import { isStringNullOrEmpty } from '@wz-utilities/string.utilities';
import { MaskConstants } from '../../../../../libs/constants/mask-constants';
import { RegexConstants } from '../../../../../libs/constants/regex-constants';
import { TextInputComponent } from './text-input.component';

@Component({
  selector: 'wz-phone-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: false,
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: PhoneInputComponent,
    },
    {
      provide: TextInputComponent,
      useExisting: PhoneInputComponent,
    },
  ],
})
export class PhoneInputComponent
  extends TextInputComponent
  implements OnInit, OnDestroy, MatFormFieldControl<string>
{
  private phoneRegex!: RegExp;

  override get controlType() {
    return 'wz-phone-input';
  }

  @Input() phoneKind!: 'mobile' | 'localPhone' | 'all';

  override ngOnInit() {
    super.ngOnInit();
    this.setPhoneRegexAndMask(this.phoneKind);
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  setPhoneRegexAndMask(phoneKind: 'mobile' | 'localPhone' | 'all'): void {
    if (isStringNullOrEmpty(this.phoneKind) || this.phoneKind === 'all') {
      this.phoneRegex = RegexConstants.AllPhone;
      this.maskConfig = MaskConstants.AllPhoneConfig;
      return;
    }

    if (this.phoneKind === 'mobile') {
      this.phoneRegex = RegexConstants.Mobile;
      this.maskConfig = MaskConstants.MobileConfig;
      return;
    }

    if (this.phoneKind === 'localPhone') {
      this.phoneRegex = RegexConstants.LocalPhone;
      this.maskConfig = MaskConstants.LocalPhoneConfig;
      return;
    }

    throw Error('[getPhoneRegex] Invalid phone kind was given : ' + phoneKind);
  }

  validate(fc: FormControl) {
    let validatorFn = Validators.pattern(this.phoneRegex);
    return validatorFn(fc);
  }
}
